/* WeBrusher Policy Consent v1.0 — theme-side only, NOT Shopify server-side validation. */
(() => {
  'use strict';
  const VERSION = '2026-10-18';
  const KEYS = ['Policy Consent', 'Policy Consent At (UTC)', 'Policy Version'];
  const ERR = 'To complete your purchase, you must agree to our Store Policies.';
  let accepted = false;
  let saving = false;
  let queued = Promise.resolve();
  let writesPending = 0;
  const root = window.Shopify?.routes?.root || '/';
  const endpoint = root + 'cart/update.js';
  const headers = {'Content-Type':'application/json','Accept':'application/json'};
  const consentNodes = () => [...document.querySelectorAll('[data-wb-policy-consent]')];
  function sync() {
    consentNodes().forEach(n => {
      const c = n.querySelector('[data-wb-policy-checkbox]');
      if(c && c.checked !== accepted)c.checked = accepted;
    });
  }
  function error(show) { consentNodes().forEach(n => {const e=n.querySelector('[data-wb-policy-error]');if(e){e.hidden=!show;e.textContent=ERR;}}); }
  function write(attributes) {
    return fetch(endpoint,{method:'POST',credentials:'same-origin',headers,body:JSON.stringify({attributes})}).then(r=>{if(!r.ok)throw Error('Shopify cart update failed: '+r.status);return r.json();});
  }
  function persist(value){
    saving = true; writesPending++;
    const attrs = value ? {'Policy Consent':'Accepted by customer','Policy Consent At (UTC)':new Date().toISOString(),'Policy Version':VERSION} : Object.fromEntries(KEYS.map(k=>[k,'']));
    queued=queued.catch(()=>{}).then(()=>write(attrs)).catch(e=>{accepted=false;sync();error(true);console.error('[WeBrusher consent]',e);}).finally(()=>{writesPending--;saving=writesPending>0;});
  }
  // Consent must be actively checked for this page visit. Never infer it from stored cart attributes.
  document.addEventListener('change',e=>{
    if(!e.target.matches('[data-wb-policy-checkbox]'))return;
    accepted=e.target.checked;
    sync();error(false);persist(accepted);
  },true);
  function isCartCheckout(target){
    return Boolean(target.closest('.cart__checkout-button,[name="checkout"],#checkout'));
  }
  document.addEventListener('click',e=>{
    const b=e.target.closest('button,input[type="submit"],a');
    if(!b || !isCartCheckout(b))return;
    if(!accepted || saving){
      e.preventDefault();e.stopImmediatePropagation();error(true);
      const checkbox=consentNodes().find(n=>n.getClientRects().length)?.querySelector('[data-wb-policy-checkbox]');
      checkbox?.focus({preventScroll:false});
    }
  },true);
  document.addEventListener('submit',e=>{
    const form=e.target;
    if(!(form instanceof HTMLFormElement))return;
    if(form.id!=='cart-form' && !form.matches('form[action*="/cart"]'))return;
    const submitter=e.submitter;
    if(submitter?.name==='checkout' || submitter?.id==='checkout') {
      if(!accepted || saving){e.preventDefault();e.stopImmediatePropagation();error(true);}
    }
  },true);
  // Clear any previous cart acceptance when the storefront loads: no implied/pre-checked consent.
  persist(false);
  // Theme cart summary can be replaced after Ajax cart changes; keep checkboxes in sync.
  new MutationObserver(()=>sync()).observe(document.documentElement,{subtree:true,childList:true});
})();